var githubIco = 'fab fa-github'
var twitterIco = 'fab fa-twitter'
var discordIco = 'fab fa-discord'
var guideIco = 'fal fa-book-open'
var facebookIco = 'fab fa-facebook'
var instaIco = 'fab fa-instagram'

const icons = {
    github: githubIco,
    twitter: twitterIco,
    discord: discordIco,
    guide: guideIco,
    facebook: facebookIco,
    instagram: instaIco
}

export default icons;